<main>
  <app-new-sidebar class="destop-view"></app-new-sidebar>

  <div class="h-screen w-screen flex flex-col">
    <div class="container">
      <div
        id="toolbar-container"
        style="max-width: 835px"
        class="flex items-center flex-col"
      >
        <editor-toolbar-top></editor-toolbar-top>
        <app-tabview-sidebar class="tab-view"></app-tabview-sidebar>
      </div>
    </div>

    <div
      class="container flex-1 grid p-base pb-1 gap-lg overflow-hidden"
      [ngClass]="{ 'grid-cols-2': editorState.response }"
    >
      <div class="h-full flex flex-col overflow-hidden">
        <div
          class="h-full flex flex-col border-sections rounded-lg overflow-hidden"
        >
          <div class="flex items-center justify-between p-symmetric pt-2 pl-1">
            <div class="border-none" #editorToolbar>
              <span class="has-tooltip">
                <button class="ql-bold"></button>
                <span class="tooltip-content tooltip-bottom">Bold</span>
              </span>
              <span class="has-tooltip">
                <button class="ql-italic"></button>
                <span class="tooltip-content tooltip-bottom">Italic</span>
              </span>
              <span class="has-tooltip">
                <button class="ql-underline"></button>
                <span class="tooltip-content tooltip-bottom">Underline</span>
              </span>
              <span class="has-tooltip">
                <button class="ql-align" value=""></button>
                <span class="tooltip-content tooltip-bottom">Align Left</span>
              </span>
              <span class="has-tooltip">
                <button class="ql-align" value="center"></button>
                <span class="tooltip-content tooltip-bottom">Align Center</span>
              </span>
              <span class="has-tooltip">
                <button class="ql-align" value="right"></button>
                <span class="tooltip-content tooltip-bottom">Align Right</span>
              </span>
              <span class="has-tooltip">
                <button class="ql-list" value="bullet"></button>
                <span class="tooltip-content tooltip-bottom"
                  >Unordered List</span
                >
              </span>
              <span class="has-tooltip">
                <button class="ql-list" value="ordered"></button>
                <span class="tooltip-content tooltip-bottom">Ordered List</span>
              </span>
              <span class="has-tooltip">
                <button class="ql-blockquote"></button>
                <span class="tooltip-content tooltip-bottom">Blockquote</span>
              </span>
            </div>

            <!-- <div
            style="position: relative"
            class="grid items-center switch-language-dropdown-container"
          >
            <button
              (click)="toggleReportMenu($event)"
              class="switch-language-dropdown flex items-center gap-default justify-between"
            >
              <span class="flex gap-default items-center text-sm">
                <app-icons-free-tools
                  *ngIf="!iconRequireReattachment"
                  [name]="languages[selectedLanguage].icon"
                ></app-icons-free-tools>
                {{ languages[selectedLanguage].name }}
              </span>
              <app-icons name="chevronDown"></app-icons>
            </button>

            <ul
              style="display: none"
              class="language-menu p-0"
              (click)="switchLanguage($event)"
            >
              <li
                [attr.data-language]="language"
                *ngFor="let language of Object.keys(languages)"
              >
                <app-icons-free-tools
                  [name]="languages[language].icon"
                ></app-icons-free-tools>
                {{ languages[language].name }}
              </li>
            </ul>
          </div> -->
          </div>

          <div
            class="p-symmetric pt-0 flex-1 overflow-y-auto scrollable h-full"
            [ngClass]="{ relative: !editorEnabled }"
          >
            <div #editor spellcheck="false"></div>

            <section
              class="absolute inset-0 p-symmetric pt-2"
              [ngClass]="{ 'd-none': !(!editorEnabled && !editorState.words) }"
              (click)="renderEditor()"
              style="cursor: text"
            >
              <h4 class="mb-3" style="font-size: 20px">
                Type or paste (Ctrl+V) your text here.
              </h4>
              <p>Or, upload a document.</p>
              <app-upload-file></app-upload-file>
            </section>
          </div>

          <div class="p-symmetric flex gap-default justify-between text-sm">
            <div class="flex gap-default">
              <button
                class="mode-toggles px-3"
                [ngClass]="{ active: editorState.mode === 'paragraph' }"
                (click)="editorState.mode = 'paragraph'"
              >
                Paragraph
              </button>
              <button
                class="mode-toggles px-3"
                [ngClass]="{ active: editorState.mode === 'key_sentences' }"
                (click)="editorState.mode = 'key_sentences'"
              >
                Sentences
              </button>
            </div>

            <div
              class="flex items-center gap-default flex-1 justify-end pr-1 text-sm"
            >
              <span class="fw-medium">Summary length: Short</span>
              <div class="flex items-center">
                <input
                  type="range"
                  class="input-range"
                  min="1"
                  max="100"
                  value="50"
                  id=""
                  [(ngModel)]="editorState.percent"
                />
              </div>
              <span class="fw-medium">Long</span>
            </div>
          </div>
        </div>

        <div
          class="flex justify-between items-center p-base px-0"
          style="min-height: 78px"
        >
          <ul
            class="flex gap-default items-center list-style-none m-0 p-0 text-sm"
          >
            <li>Words: {{ f(editorState.words) }}</li>
            <li>|</li>
            <li>Characters: {{ f(editorState.characters) }}</li>
          </ul>

          <button
            *ngIf="!editorState.response"
            [disabled]="editorState.state === 'loading'"
            [ngClass]="{
              'check-grammar-btn-loading': editorState.state === 'loading'
            }"
            class="check-grammar-btn"
            (click)="editorState.words < 15 ? invokeModal($event) : summarize()"
            [attr.data-target]="'empty-content-modal'"
          >
            {{ editorState.state === "loading" ? "Summarizing" : "Summarize" }}
          </button>
        </div>
      </div>
      <div
        class="h-full overflow-hidden flex flex-col"
        *ngIf="editorState.response"
      >
        <div
          class="h-full flex flex-col border-sections rounded-lg overflow-hidden"
        >
          <!-- Results Container -->
          <div class="flex items-center" style="min-height: 64px">
            <h3 class="fs-4 fw-medium m-0" style="padding-inline-start: 1.5rem">
              Results
            </h3>
          </div>

          <div
            class="flex-1 h-full p-base py-0 response-container overflow-y-auto scrollable"
            *ngIf="editorState.response"
            #output
          >
            @if (Array.isArray(editorState.response)) {
            <ul class="grid gap-default" style="line-height: 2.5rem">
              @for(r of editorState.response; track r) {
              <li>{{ r }}</li>
              }
            </ul>
            } @else {
            <p style="line-height: 2.5rem">
              {{ editorState.response }}
            </p>
            }
          </div>

          <section
            class="h-full grid place-items-center flex-1"
            *ngIf="!editorState.response"
          >
            <app-empty-content></app-empty-content>
          </section>
          <div style="min-height: 69px" class="md-hidden"></div>
        </div>

        <div
          class="flex justify-between items-center"
          style="min-height: 78px"
          *ngIf="editorState.response"
        >
          <ul
            class="flex gap-default items-center list-style-none m-0 p-0 text-sm"
          >
            <!-- show count for the right hand section -->
            <li>Words: {{ f(editorState.res_words) }}</li>
            <li>|</li>
            <li>Characters: {{ f(editorState.res_characters) }}</li>
          </ul>

          <ul class="flex gap-default items-center list-style-none m-0 p-0">
            <li>
              <button
                class="btn-outline has-tooltip"
                (click)="copyToClipboard()"
              >
                <app-icons name="copyIcon" />

                <span class="tooltip-content tooltip-top">Copy</span>
              </button>
            </li>
            <li>
              <button class="btn-outline has-tooltip" (click)="clearEditor()">
                <app-icons name="clearIcon" />

                <span class="tooltip-content tooltip-top">Clear</span>
              </button>
            </li>
            <li>
              <button
                class="btn-outline has-tooltip"
                (click)="downloadReport()"
              >
                <app-icons-free-tools name="downloadTabIcon" />

                <span class="tooltip-content tooltip-top">Download</span>
              </button>
            </li>
            <li>
              <button
                [disabled]="editorState.state === 'loading'"
                [ngClass]="{
                  'check-grammar-btn-loading': editorState.state === 'loading'
                }"
                class="check-grammar-btn"
                (click)="
                  editorState.words < 15 ? invokeModal($event) : summarize()
                "
                [attr.data-target]="'empty-content-modal'"
              >
                {{
                  editorState.state === "loading" ? "Summarizing" : "Summarize"
                }}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <app-modal parent="content-exceeds-words-limit-modal">
    <modal-content>
      <section class="text-center grid justify-center">
        <h3>Content Exceeds Words Limit</h3>

        <p>
          Please reduce your content to less than
          {{ f(authLimits[authState].words) }} words.
        </p>

        <div>
          <button
            class="check-grammar-btn w-unset"
            (click)="dismissModal($event)"
            style="max-width: unset !important"
          >
            Dismiss
          </button>
        </div>
      </section>
    </modal-content>
  </app-modal>

  <app-modal parent="empty-content-modal">
    <modal-content>
      <section class="text-center grid justify-center">
        <h3>Enter at least 15 words.</h3>

        <p>Please enter at least 15 words to proceed.</p>

        <div>
          <button
            class="check-grammar-btn w-unset"
            (click)="dismissModal($event)"
            style="max-width: unset !important"
          >
            Dismiss
          </button>
        </div>
      </section>
    </modal-content>
  </app-modal>
</main>
